import { Link } from "react-router-dom";
import { useBookshelf } from "~/contexts/BookshelfContext";
import stories from "~/stories";
import StoryCard from "~/components/StoryCard";

export default function BookshelfPage() {
  const { favorites, readStories } = useBookshelf();

  const favoriteStories = stories.filter((s) => favorites.includes(s.id));
  const recentlyRead = stories.filter((s) => readStories.includes(s.id));

  return (
    <div className="min-h-screen">
      <div className="bg-gray-50 dark:bg-gray-800 py-12 px-6">
        <div className="max-w-6xl mx-auto">
          <Link to="/" className="text-gray-500 hover:text-gray-700 dark:text-gray-400 text-sm mb-4 inline-block">
            &larr; Back to home
          </Link>
          <h1 className="text-4xl font-bold mb-2 text-gray-900 dark:text-white">My Bookshelf</h1>
          <p className="text-lg text-gray-600 dark:text-gray-300">Your favorite and recently read stories</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-8">
        {/* Favorites */}
        <div className="mb-12">
          <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-gray-200">Favorites</h2>
          {favoriteStories.length === 0 ? (
            <p className="text-gray-400 py-8 text-center">
              No favorites yet. Tap the heart on any story to save it here.
            </p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {favoriteStories.map((story) => (
                <StoryCard key={story.id} story={story} />
              ))}
            </div>
          )}
        </div>

        {/* Recently Read */}
        <div>
          <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-gray-200">Recently Read</h2>
          {recentlyRead.length === 0 ? (
            <p className="text-gray-400 py-8 text-center">
              No stories read yet. Start exploring!
            </p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {recentlyRead.map((story) => (
                <StoryCard key={story.id} story={story} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
